import { Controller } from "@hotwired/stimulus"

// Copia o conteúdo de `sourceTarget` para a clipboard e dá feedback visual
// no botão disparador (troca rótulo + ícone de check + cor de sucesso por
// `resetDelay` ms). Funciona mesmo quando a async Clipboard API está
// indisponível ou falha (contexto não-seguro, permissão negada) usando
// fallback com execCommand.
export default class extends Controller {
  static targets = ["source"]
  static values = {
    successText: { type: String, default: "Copiado!" },
    resetDelay:  { type: Number, default: 2000 }
  }

  async copy(event) {
    const btn = event.currentTarget
    const text = this.sourceTarget.value || this.sourceTarget.textContent

    const ok = await this.writeToClipboard(text)
    if (!ok) return

    this.showFeedback(btn)
  }

  async writeToClipboard(text) {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch {
        // cai no fallback abaixo
      }
    }
    return this.legacyCopy(text)
  }

  legacyCopy(text) {
    const el = this.sourceTarget
    const wasReadOnly = el.readOnly
    el.readOnly = false
    el.focus()
    el.select()
    let ok = false
    try {
      ok = document.execCommand("copy")
    } catch {
      ok = false
    }
    el.readOnly = wasReadOnly
    return ok
  }

  showFeedback(btn) {
    if (btn.dataset.clipboardBusy === "true") return
    btn.dataset.clipboardBusy = "true"

    const original = btn.innerHTML
    const successClass = "text-(--success)"
    btn.classList.add(successClass)
    // O <i data-lucide="check"> é renderizado pelo MutationObserver do
    // application.js (que detecta placeholders lucide adicionados ao DOM).
    btn.innerHTML = `<i data-lucide="check" style="stroke-width:2;width:16px;height:16px;"></i>${this.successTextValue}`

    setTimeout(() => {
      btn.innerHTML = original
      btn.classList.remove(successClass)
      delete btn.dataset.clipboardBusy
    }, this.resetDelayValue)
  }
}
